import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createProtocol = (data) => ({
  type: ActionTypes.PROTOCOL_CREATE,
  payload: {
    data,
  },
});

export const updateProtocol = (id, data) => ({
  type: ActionTypes.PROTOCOL_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteProtocol = (id) => ({
  type: ActionTypes.PROTOCOL_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createProtocolRequested = (data) => ({
  type: ActionTypes.PROTOCOL_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createProtocolSucceeded = (protocol) => ({
  type: ActionTypes.PROTOCOL_CREATE_SUCCEEDED,
  payload: {
    protocol,
  },
});

export const createProtocolFailed = (error) => ({
  type: ActionTypes.PROTOCOL_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createProtocolReceived = (protocol) => ({
  type: ActionTypes.PROTOCOL_CREATE_RECEIVED,
  payload: {
    protocol,
  },
});

export const updateProtocolRequested = (id, data) => ({
  type: ActionTypes.PROTOCOL_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateProtocolSucceeded = (protocol) => ({
  type: ActionTypes.PROTOCOL_UPDATE_SUCCEEDED,
  payload: {
    protocol,
  },
});

export const updateProtocolFailed = (id, error) => ({
  type: ActionTypes.PROTOCOL_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateProtocolReceived = (protocol) => ({
  type: ActionTypes.PROTOCOL_UPDATE_RECEIVED,
  payload: {
    protocol,
  },
});

export const deleteProtocolRequested = (id) => ({
  type: ActionTypes.PROTOCOL_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteProtocolSucceeded = (protocol) => ({
  type: ActionTypes.PROTOCOL_DELETE_SUCCEEDED,
  payload: {
    protocol,
  },
});

export const deleteProtocolFailed = (id, error) => ({
  type: ActionTypes.PROTOCOL_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteProtocolReceived = (protocol) => ({
  type: ActionTypes.PROTOCOL_DELETE_RECEIVED,
  payload: {
    protocol,
  },
});
